// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"6f77ef8e","162":"2313a6b8","302":"41f872af","517":"2313a6b8","768":"481a97b5"}[chunkId] + ".chunk.css";
};